import { render, staticRenderFns } from "./ForgetPwd.vue?vue&type=template&id=2ce4ad24&scoped=true"
import script from "./ForgetPwd.vue?vue&type=script&lang=js"
export * from "./ForgetPwd.vue?vue&type=script&lang=js"
import style0 from "./ForgetPwd.vue?vue&type=style&index=0&id=2ce4ad24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce4ad24",
  null
  
)

export default component.exports